import { Pressable, StyleSheet } from 'react-native'

import { FigmaChevronRightIcon } from '../icons/FigmaSystemIcons'
import { ChainAvatar } from '../icons/ChainAvatar'
import { Box, Text, useTheme } from '../theme/restyle'

export interface SelectedChainRowProps {
  /** Section label above the chain name, e.g. `Selected chain`. */
  label: string
  /** The chain's display name, e.g. `Base`. */
  name: string
  /** Full CDN logo URL for the 32px chain icon. */
  iconUri: string
  accessibilityLabel: string
  onPress?: () => void
}

/**
 * The tappable "Selected chain" card on the Transfer screen. Shows the chain the
 * deposit address was generated for and opens the chain picker to change it.
 */
export function SelectedChainRow({
  label,
  name,
  iconUri,
  accessibilityLabel,
  onPress,
}: SelectedChainRowProps) {
  const theme = useTheme()
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
    >
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        borderRadius="element"
        style={[styles.card, { backgroundColor: theme.background.secondary }]}
      >
        <Box flexDirection="row" alignItems="center" style={styles.chain}>
          <ChainAvatar uri={iconUri} size={32} />
          <Box>
            <Text
              variant="detail"
              style={{ color: theme.content.elements.secondary }}
            >
              {label}
            </Text>
            <Text
              variant="bodyMedium"
              numberOfLines={1}
              style={{ color: theme.content.elements.primary }}
            >
              {name}
            </Text>
          </Box>
        </Box>
        <FigmaChevronRightIcon
          size={20}
          color={theme.content.button.icon.default}
        />
      </Box>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  card: { padding: 16 },
  chain: { gap: 12, flex: 1 },
})
